import LocalStorageModel from "../prototypes/LocalStorageModel";

//
// Model Stockout Product
//

class StockoutProductModel extends LocalStorageModel<any> {
  name = "StockoutProductModel";
  idAttribute = "id_store";
  route = "apiStockoutProductModel";
  defaults() {
    return { products: [] };
  }
  initialize(attributes?: any, options?: any): void {
    // ObjectModel constructor heritage
    super.initialize.apply(this, [attributes, options]);
    //
  }
  isStockout(id_product: string | number): boolean {
    return this.get("products").indexOf(id_product) >= 0;
  }
}

StockoutProductModel.prototype.name = "StockoutProductModel";
StockoutProductModel.prototype.idAttribute = "id_store";
StockoutProductModel.prototype.route = "apiStockoutProductModel";
StockoutProductModel.prototype.url = function () {
  return `/stockoutproduct/${this.id}`;
};

export default StockoutProductModel;
